import React from 'react';
import { bool, number, string } from 'prop-types';

import { runWhenIdle } from '../util/idle';

class AdContainer extends React.Component {
  componentDidMount() {
    if (window) {
      // Deferred so ad rendering doesn't compete with the compare UI for the critical rendering
      // path. Trade-off: a visitor who leaves within the idle-callback delay may see no ad at
      // all, vs. one appearing immediately - an intentional choice, not an oversight.
      // Note: does not re-request on a later hideAdContainer transition (e.g. logging out
      // mid-session) - tried once, but it fought with AdSense's own push queue and produced a
      // broken partial render, worse than the plain "needs a refresh" behavior being replaced.
      // Not revisiting without a clearer understanding of AdSense's queueing semantics.
      runWhenIdle(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      });
    }
  }

  render() {
    return (
      <div
        style={{
          position: 'relative',
          display: this.props.hideAdContainer ? 'none' : 'flex',
          marginTop: 20,
          marginBottom: 20,
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #888888',
          borderRadius: 4,
          height: this.props.height,
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 1,
            left: 3,
            fontSize: 8,
            fontWeight: 600,
            color: '#555555'
          }}
        >
          ADVERTISEMENT
        </div>
        <ins
          className="adsbygoogle"
          style={{
            display: 'inline-block',
            width: '100%',
            height: this.props.height,
            justifyContent: 'center'
          }}
          data-ad-client="ca-pub-4700667168875048"
          data-ad-slot={this.props.adSlotId}
        />
      </div>
    );
  }
}

AdContainer.propTypes = {
  adSlotId: string,
  hideAdContainer: bool,
  height: number
};

AdContainer.defaultProps = {
  height: 100
};

export default AdContainer;
